import React, { useState } from "react";
import styles from "styles/genai/Edetail.module.scss";
import { useHistory } from "react-router-dom";
import { routes } from "Uitls/Util";

export const ProceedCMSD = ({ show, onClose, setShowCmsd }) => {
  const history = useHistory();
  if (!show) return null;
  const handleProceed = () => {
    onClose();
    history.push(routes.dashboard);
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.proceedcontent}
        onClick={(e) => e.stopPropagation()}
      >
        <article className={styles.proceedhead}>
          <span className={styles.previewconttop}>PROCEED TO MODULE DASHBOARD</span>
        </article>

        <div className={styles.proceedpreview}>
          
            Are you sure you want to proceed to the Module Dashboard with the
            above metadata information and elements?
          
        </div>

        <article className={styles.proceedbottom}>
          <div onClick={() => onClose()} className={styles.cmsdedittext}>
            NO
          </div>
          <div></div>
          <div
            onClick={() => {
              handleProceed();
            }}
          >
            <button className={styles.proceedcontinue}>YES, PROCEED</button>
          </div>
        </article>
      </div>
    </div>
  );
};
